export default "__VITE_ASSET__CSgtS1VI__"